<mapfre-modal [modalOptions]="mortgageeModalOptions" [hideModal]="hideModal" (closeModal)="resetHideModal()">
  <div class="modal-overlays">
    <div class="close-icon">
      <img (click)="cancelModal(true)" src="assets/img/images/icon-close-mortgagee.svg" />
    </div>
    <div class="">
      <div class="warning-icon-container">
        <img src="assets/img/images/icon-warning-mortgagee.svg" class="warning-icon" />
      </div>
      <div class="modal-text-container">
        <p *ngIf="isMortgagee" class="modal-text">
          {{ 'MORTGAGEE_MODAL_MESSAGE_ONE' | translate }} <br>
{{ 'MORTGAGEE_MODAL_MESSAGE_TWO' | translate }}
        </p>
        <p *ngIf="!isMortgagee && isPaidInFullPending" class="modal-text pif-pending-info">
          Good news—you've paid enough to qualify for the Paid in full discount. Continuing may result in an overpayment.
        </p>
        <hr class="mortgagee-hr">
      </div>
    </div>
    <div class="modal-footer">
      <mapfre-button additionalClasses="ghost secondary small-btn modal-small-btn" class="btn-cancel-custom"
        (click)="cancelModal(true)">
        {{ 'CANCEL' | translate }}
      </mapfre-button>
      <mapfre-button class="btn-primary-custom" (click)="onProceed()">
        {{ 'PROCEED_PAYMENT' | translate }}
      </mapfre-button>
    </div>
  </div>
</mapfre-modal>